import { motion } from "framer-motion";
import { MapPin, Facebook } from "lucide-react";

const projects = [
  {
    id: "zona-oeste",
    image: "https://msvision.com.ar/wp-content/uploads/2023/11/PROYECTO1.jpg",
    title: "PLAN 70K POLÍGONO ZONA OESTE",
    location: "Zona Oeste · Buenos Aires",
    tag: "Red HFC",
    description: "Despliegue de red para cobertura de 70.000 usuarios en el polígono Zona Oeste del AMBA.",
  },
  {
    id: "moron",
    image: "https://msvision.com.ar/wp-content/uploads/2023/11/PROYECTO2.jpg",
    title: "F.O. FT TH-RED DIST. POLÍGONO MORÓN",
    location: "Morón · Buenos Aires",
    tag: "Fibra Óptica",
    description: "Tendido de fibra óptica FTTH para distribución de red en el polígono Morón.",
  },
];

export const Projects = () => {
  return (
    <section
      id="proyectos"
      data-testid="projects-section"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ backgroundColor: "#003366" }}
    >
      {/* Decorative bg */}
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "radial-gradient(circle at 20% 50%, #00AEEF 0%, transparent 50%)" }} />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-heading font-semibold text-sm tracking-widest uppercase block mb-3">
            Casos de éxito
          </span>
          <h2 className="font-heading font-black text-white text-4xl md:text-5xl mb-4">
            Proyectos Destacados
          </h2>
          <p className="font-body text-white/60 text-lg max-w-xl mx-auto">
            Infraestructura de red real desplegada en el AMBA
          </p>
          <div className="w-20 h-1 bg-accent mx-auto mt-6 rounded-full" />
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, i) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, x: i === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              data-testid={`project-card-${project.id}`}
              className="group relative overflow-hidden rounded-2xl border border-white/10 hover:border-accent/50 transition-all duration-400 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  onError={(e) => {
                    e.target.parentElement.style.background = "linear-gradient(135deg, #1A1A2E, #003366)";
                    e.target.style.display = "none";
                  }}
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#003366] via-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
                {/* Tag */}
                <span className="absolute top-4 left-4 bg-accent text-white text-xs font-heading font-bold px-3 py-1.5 rounded-full">
                  {project.tag}
                </span>
                {/* Facebook share */}
                <button
                  data-testid={`project-fb-${project.id}`}
                  className="absolute top-4 right-4 w-9 h-9 bg-[#1877F2] rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-200"
                  onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, "_blank")}
                >
                  <Facebook size={16} className="text-white" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 bg-[#002855]">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading font-bold text-white text-xl mb-2 leading-snug">
                      {project.title}
                    </h3>
                    <p className="font-body text-white/60 text-sm mb-3 leading-relaxed">
                      {project.description}
                    </p>
                    <div className="flex items-center gap-2 text-accent text-sm font-body">
                      <MapPin size={14} />
                      <span>{project.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
